// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MegaMenu-module__wrap--wlx1n","grid":"MegaMenu-module__grid--3eylb","menu":"MegaMenu-module__menu--21T7Y","fulfilment":"MegaMenu-module__fulfilment--3u_Ev"};